import EverTrue from "app";

export const trackOutreachAction = (type) => {
  const track = (type) => {
    EverTrue.track.set("outreach_action", { type });
  };
  const { pathname } = window.location;
  switch (type) {
    case "open_dialer":
      if (pathname === "/cadences") {
        track("open_dialer_from_cadences");
      } else if (pathname.includes("/contact")) {
        track("open_dialer_from_profile");
      }
      break;
    case "open_emailer":
      if (pathname === "/cadences") {
        track("open_emailer_from_cadences");
      } else if (pathname.includes("/contact")) {
        track("open_emailer_from_profile");
      }
      break;
    default:
      track(type);
      break;
  }
};

export const isDynamicTemplate = (template) => {
  const regex = /\{\{.*?\}\}/g;
  return regex.test(template);
};
